import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import dayjs from "dayjs";
import { colorsPalettes } from "@similarweb/styles";
import { serverResponseFormat } from "@similarweb/pro-logic-components";

export const getGA4FirstDataPointDate = (graph, timeGranularity) => {
    if (!graph.data?.Ga4FirstOccurrence) {
        return [];
    }
    return Object.entries(graph?.data?.Ga4FirstOccurrence).reduce((acc, [domain, value]) => {
        if (typeof value === "string") {
            let bellAlertDateAppearance = "";
            switch (timeGranularity.name) {
                case GranularityNames.DAILY:
                    bellAlertDateAppearance = value;
                    break;
                case GranularityNames.WEEKLY:
                case GranularityNames.MONTHLY:
                    bellAlertDateAppearance = dayjs(value).startOf("M").format(serverResponseFormat);

                    break;
            }
            const domainObj = {
                domain,
                date: new Date(bellAlertDateAppearance).getTime(),
                value: 0,
                backgroundColor: colorsPalettes.carbon[0],
                icon: "alert-outlined",
                isTooltipLineDisabled: false,
                isTooltipDisabled: true,
            };
            acc.push(domainObj);
        }
        return acc;
    }, []);
};
